<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-market-select
            initValue
            adMarket
            :clearable="false"
            v-model="filter.marketId"
            placeholder="全部店铺"
            @input="marketChange($event)"
            width="130px"
        ></gj-market-select>
        <gj-select
            v-model="filter.campaignIds"
            :options="option.campaignOption"
            placeholder="所有广告活动"
            type="multi-check"
            :loading="option.campaignLoading"
            @input="campaignChange($event)"
            width="160px"
        ></gj-select>
        <gj-select
            v-model="filter.groupIds"
            :options="option.groupOption"
            :loading="option.groupLoading"
            placeholder="所有广告组"
            type="multi-check"
            width="160px"
        ></gj-select>
        <gj-select
            v-model="filter.operationResult"
            :options="option.operationResults"
            placeholder="操作结果"
            width="120px"
        ></gj-select>
        <gj-select
            v-model="filter.opType"
            :options="option.opTypeOption"
            placeholder="所有操作类型"
            width="140px"
        ></gj-select>
        <gj-search-input
            v-model="filter.keyword"
            width="200px"
            placeholder="对象名称"
        ></gj-search-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="操作时间(站点时间)"
        ></gj-date-picker>
        <template #right>
          <gj-tool-group help></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          name="strategyAdjustLog"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import {getAdsAdjustStrategyLog, SP} from "@/api/ad";
  import {AdStrategyEnum} from "../common/enum";
  import {mapGetters} from "vuex";
  import {convertToDate} from "@/utils/date.util";
  import {AdCampaignEnum, AdGroupEnum, AdPlacementEnum, AdTargetEnum} from "../../common/enum";

  export default {
    name: "app-ad-strategy-adjust-log",
    mixins: [queryMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'localUpdateDate', header: '时间(站点时间)', field: 'localUpdateDate', width: '200px'},
          {id: 'marketId', header: '站点', field: 'option:marketId', width: '180px', options: () => this.marketOption},
          {id: 'campaignName', header: '广告活动', field: 'campaignName', minWidth: '200px', overflowLine: 1},
          {id: 'groupName', header: '广告组', field: 'groupName', minWidth: '180px', overflowLine: 1},
          {id: 'objectName', header: '对象名称', field: 'objectName', overflowLine: 1, minWidth: '200px'},
          {id: 'objectType', header: '操作类型', field: 'option:operateType', width: '100px', options: AdStrategyEnum.opTypeOption},
          {id: 'content', header: '调整记录', field: 'content', minWidth: '200px', overflowLine: 1},
          {id: 'operationResult', header: '操作结果', field: 'operationResult', minWidth: '100px'},
          {id: 'detail', header: '详情', field: 'detail', minWidth: '200px', overflowLine: 1},
        ],
        filter: {
          marketId: null,
          campaignIds: [],
          groupIds: [],
          operationResult: null,
          opType: null,
          keyword: null,
          date: null
        },
        option: {
          campaignOption: [],
          campaignLoading: false,
          groupOption: [],
          groupLoading: false,
          operationResults: [
            {id: "成功", text: "成功"},
            {id: "失败", text: "失败"},
          ],
          opTypeOption: AdStrategyEnum.opTypeOption
        },
        notStorage: true
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            marketId: this.filter.marketId,
            campaignIds: [],
            groupIds: [],
            operationResult: null,
            opType: null,
            keyword: null,
            date: null
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: defaultVal(this.filter.marketId, null),
            campaignIds: defaultVal(this.filter.campaignIds, []),
            groupIds: defaultVal(this.filter.groupIds, []),
            operationResult: defaultVal(this.filter.operationResult, null),
            operateType: defaultVal(this.filter.opType, null),
            objectName: defaultVal(this.filter.keyword, null),
            createDateType: 1,// 时间类型 system: 0,market: 1,
            startDate: this.filter.date ? convertToDate(this.filter.date[0]) : null,
            endDate: this.filter.date ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getAdsAdjustStrategyLog(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      marketChange(marketId) {
        this.option.campaignLoading = true;
        this.option.campaignOption = [];
        this.filter.campaignIds = [];
        this.option.groupOption = [];
        this.filter.groupIds = [];
        SP.selectSpCampaigns({
          marketId
        })
          .then(({data}) => {
            this.option.campaignOption = data.map(e => ({
              id: e.campaignId,
              text: e.campaignName
            }));
          })
          .then(() => this.option.campaignLoading = false);
      },
      campaignChange(campaignIds) {
        if (isMeaningless(this.filter.marketId)) {
          return;
        }
        this.option.groupOption = [];
        this.filter.groupIds = [];
        this.option.groupLoading = true;
        SP.selectSpGroups({
          marketId: this.filter.marketId,
          campaignIds: campaignIds,
          state: [0, 1]
        })
          .then(({data}) => {
            this.option.groupOption = data.map(e => ({
              id: e.groupId,
              text: e.groupName,
              bid: e.defaultBid
            }))
          })
          .then(() => this.option.groupLoading = false);
      },
    }
  }
</script>

<style scoped>

</style>
